import { render, staticRenderFns } from "./PastDuePortfolio.vue?vue&type=template&id=5864062f&scoped=true"
import script from "./PastDuePortfolio.vue?vue&type=script&lang=js"
export * from "./PastDuePortfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5864062f",
  null
  
)

export default component.exports